import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../core/services/auth.service';
import { UserRole } from '../core/models/enums';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class HomeComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  ngOnInit() {
    const role = this.authService.userRole();
    if (role) {
      if (role === UserRole.SUPERADMIN) {
        this.router.navigate(['/business']);
      } else if (role === UserRole.ADMIN || role === UserRole.POS) {
        this.router.navigate(['/admin/dashboard']);
      } else if (role === UserRole.RESOURCE || role === UserRole.USER) {
        this.router.navigate(['/admin/my-agenda']);
      } else {
        this.router.navigate(['/dashboard']);
      }
    }
  }
}
